<core-helpers-box-http-error [code]="error.code" [message]="error.text"></core-helpers-box-http-error>
